import axios from '@/axios';

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/favorites/`;

const state = {
  favorites: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
};

const mutations = {
  SET_FAVORITES(state, {count, next, previous, results}) {
    state.favorites.count = count;
    state.favorites.next = next;
    state.favorites.previous = previous;
    state.favorites.results = results;
  },
  TOGGLE_FAVORITE(state, favorite) {
    const index = state.favorites.results.findIndex(fav => fav.id === favorite.id);
    if (index !== -1) {
      state.favorites.results.splice(index, 1);
      state.favorites.count -= 1;
    } else {
      state.favorites.results.push(favorite);
      state.favorites.count += 1;
    }
  },
  ADD_FAVORITE(state, favorite) {
    state.favorites.results.push(favorite);
    state.favorites.count += 1;
  },
  REMOVE_FAVORITE(state, propertyId) {
    const index = state.favorites.results.findIndex(fav => fav.propiedad.id === propertyId);
    if (index !== -1) {
      state.favorites.results.splice(index, 1);
      state.favorites.count -= 1;
    }
  }
};

const actions = {
  async FETCH_FAVORITES({ commit }, params = {}) {
    try {
      const response = await axios.get(API_BASE, {
        params,
        withCredentials: true,
      });
      commit('SET_FAVORITES', response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async TOGGLE_FAVORITE({ commit }, propertyId) {
    try {
      const response = await axios.post(
        API_BASE,
        { propiedad: propertyId },
        { withCredentials: true }
      );
      if (response.status === 201) {
        commit('ADD_FAVORITE', response.data);
      }
      if (response.status === 204) {
        commit('REMOVE_FAVORITE', propertyId);
      }
    } catch (error) {
      console.error(error);
    }
  },
};

const getters = {
  allFavorites: state => state.favorites.results,
  favoritesCount: state => state.favorites.count,
  favoritesNext: state => state.favorites.next,
  favoritesPrevious: state => state.favorites.previous,
  isFavorite: state => id => state.favorites.results.some(fav => fav.propiedad === id),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};